import { Button } from "@/components/ui/button";
import { DadosResumoGiro } from "@/dtos/Request/FinalizarCompraSorteioGiroDto";
import { PresenteadoDto } from "@/services/AcessoService";
import { DrawerPagamentoParaOutraPessoa } from "@/pages/FinalizarCompra/DrawerPagamentoParaOutraPessoa";
import { FinalizarCompraTermos } from "@/pages/FinalizarCompra/FinalizarCompraTermos";
import { useState } from "react";
import { FinalizarCompraGiroResumo } from "./FinalizarCompraGiroResumo";

interface FinalizarCompraGiroCartaoCreditoProps {
    dadosResumo: DadosResumoGiro;
    formik: any;
    presenteados: PresenteadoDto[];
    handlePresenteados: (action: "remove" | "load", presenteado?: PresenteadoDto) => void;
}

export function FinalizarCompraGiroCartaoCredito({
    dadosResumo,
    formik,
    presenteados,
    handlePresenteados,
}: FinalizarCompraGiroCartaoCreditoProps) {
    const [termosAceito, setTermosAceito] = useState(false);

    return (
        <div className="md:w-5/12">
            <div className="flex flex-col md:flex-row justify-between">
                <FinalizarCompraGiroResumo dadosResumo={dadosResumo} />
            </div>

            <div className="flex flex-col gap-5">
                <DrawerPagamentoParaOutraPessoa
                    handlePresenteados={handlePresenteados}
                    presenteados={presenteados}
                />
                <FinalizarCompraTermos
                    aceitarTermos={async (termos) => setTermosAceito(termos)}
                    termosAceito={termosAceito}
                />
                <Button
                    className="w-full"
                    size="xl"
                    onClick={formik.submitForm}
                    disabled={!formik.isValid || !termosAceito || formik.isSubmitting}
                    variant="default"
                >
                    {formik.isSubmitting ? "Finalizando Compra..." : "Finalizar Compra"}
                </Button>
            </div>
        </div>
    );
}
